<ng-container *ngIf="viewModel$ | async as vm">
  <section class="is-flex">
    <app-time-range [selectedTimeRange]="vm.timeRange"
      (selectedTimeRangeChange)="selectTimeRange($event)"
      [scale]="vm.scale">
    </app-time-range>
    <app-scales [selectedScale]="vm.scale" (selectedScaleChange)="selectScale($event)"></app-scales>
  </section>
</ng-container>
